type EmployeeRecord = {
  authUserId?: string;
  name?: string;
};

export type AuthUserLabelContext = {
  sessionUserId?: string | null;
  sessionUserEmail?: string | null;
  ownerAuthUserId?: string | null;
  employees?: EmployeeRecord[];
};

/** Mapa auth_user_id → etiqueta humana (correo del dueño en sesión, nombre de empleado). */
export function buildAuthUserLabelById(ctx: AuthUserLabelContext): Record<string, string> {
  const map: Record<string, string> = {};
  const email = ctx.sessionUserEmail?.trim();
  if (ctx.sessionUserId && email) {
    map[ctx.sessionUserId] = email;
  }
  for (const employee of ctx.employees ?? []) {
    const id = employee.authUserId?.trim();
    const name = employee.name?.trim();
    if (id && name) {
      map[id] = name;
    }
  }
  return map;
}

export function resolveAuthUserDisplayLabel(
  authUserId: string | null | undefined,
  labelById: Record<string, string>,
  ownerAuthUserId?: string | null
): string | null {
  const id = authUserId?.trim();
  if (!id) return null;
  const known = labelById[id];
  if (known) return known;
  if (ownerAuthUserId && id === ownerAuthUserId) return 'Dueño';
  return null;
}
